import API from '../services/api';

const api = new API();

const BASE_OPTS = { method: 'GET', disableBrowserCache: true };

class LogDownloadService {
    getReportDetails(reportId) {
        return api.getJson('/api/v2.0/get_report_status', { ...BASE_OPTS, params: { report_id: reportId } });
    }

    getTaskDetails(taskId, logType, apiType) {
        const url = apiType === 'download_2phase' ? '/api/users/self/datasources/download_2phase' : '/logs/details';
        return api.getJson(url, {
            ...BASE_OPTS,
            params: { task_id: taskId, log_type: logType, api_type: apiType },
        });
    }

    getAuditDetails(validationId, validationType) {
        return api.getJson('/api/audit/result', {
            ...BASE_OPTS,
            params: { validation_id: validationId, validation_type: validationType },
        });
    }
}

export default LogDownloadService;
